angular.module('tasks.meeting-attendance')
    .component('taskMeetingAttendanceIco', {
        bindings: {
            status: '<'
        },
        template: '<i class="fa fa-fw meeting-attendance-{{$ctrl.status}}" ng-class="{ \'fa-check-circle\': $ctrl.status === \'ACCEPTED\', \'fa-minus-circle\': $ctrl.status === \'REJECTED\', \'fa-pause-circle\': $ctrl.status === \'NOTED\'}" uib-tooltip="{{ \'task-meeting-attendance.status.\' + $ctrl.status | translate }}"></i>'
    })
